/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function PublishIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "publish", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M4.99997 5.50005H20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 9.00003V20", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M7.5 14L12.5 9.00003L17.5 14", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(PublishIcon);
export default ForwardRef;
//# sourceMappingURL=publishIcon.js.map